import format from 'moment';

/**
 * @param {number} time
 * @param {string} label
 * @return {string}
 */
function pluralize(time, label) {
  if (time === 1) {
    return time + label
  }
  return time + label + 's'
}

/**
 * @param {number} time
 */
export function timeAgo(time) {
  const between = Date.now() / 1000 - Number(time)
  if (between < 3600) {
    return pluralize(~~(between / 60), ' 分')
  } else if (between < 86400) {
    return pluralize(~~(between / 3600), '时')
  } else {
    return pluralize(~~(between / 86400), '天')
  }
}

/**
 * 20200601080000
 * @param {string} val
 */
function transDateString(val) {
  const v = val ? val.toString() : '19970101080000',
    y = v.substr(0, 4),
    o = v.substr(4, 2),
    d = v.substr(6, 2),
    h = v.substr(8, 2),
    m = v.substr(10, 2),
    s = v.substr(12, 2)
  return `${y}/${o}/${d} ${h}:${m}:${s}`
}

/**
 * 日期格式
 * @param {Date} value
 * @param {string} fmt
 */
export function dateFormat(value, fmt = 'yyyy-MM-dd HH:mm:ss') {
  if(!value){
    return ''
  }else if (!isNaN(Date.parse(value))) {
    return format(new Date(value), fmt)
  }
  return format(new Date(transDateString(value)), fmt)
}

/**
 * 数字进位换算
 * @param {number} num
 * @param {number} digits
 */
export function numberCarry(num, digits) {
  const si = [
    { value: 1e11, symbol: '千亿' },
    { value: 1e8, symbol: '亿' },
    { value: 1e4, symbol: '万' }
    // { value: 1E3, symbol: '千' }
  ]
  for (let i = 0; i < si.length; i++) {
    if (num >= si[i].value) {
      return (
        (num / si[i].value)
          .toFixed(digits)
          .replace(/\.0+$|(\.[0-9]*[1-9])0+$/, '$1') + si[i].symbol
      )
    }
  }
  return num ? num.toString() : num
}

/**
 * 隐藏手机号中间4位
 * @param {*} value
 */
export function hideMobileCenter(mobile) {
  return mobile ? mobile.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2') : '****'
}

export function stateMatching(state, arr) {
  const newArr = arr.filter(item => {
    return item.value == state
  })

}
